"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachedFetch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var cachedFetch = exports.cachedFetch = (0, _react.cache)(function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (endpoint, headers, body, cacheOptions) {
    var headersObj = JSON.parse(headers);
    var cacheOptionsObj = JSON.parse(cacheOptions);
    var res = yield fetch(endpoint, _objectSpread({
      method: 'POST',
      headers: headersObj,
      body
    }, cacheOptionsObj));
    if (!res.ok) {
      return null;
    }
    return yield res.json();
  });
  return function (_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}());